import { render, staticRenderFns } from "./CountryDetailComponent.vue?vue&type=template&id=404c2715&scoped=true"
import script from "./CountryDetailComponent.vue?vue&type=script&lang=js"
export * from "./CountryDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./CountryDetailComponent.vue?vue&type=style&index=0&id=404c2715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c2715",
  null
  
)

export default component.exports